<div class="backdrop"></div>
<div tabindex="0" class="transcript" role="dialog" aria-hidden="false"
  data-keyboard="true" data-backdrop="static" aria-modal="true">
  <button class="close" aria-label="{{ t 'transcriptClose'}}"></button>
  <h2 aria-level="2">{{{t 'transcript' }}}</h2>
  <div class="text">
    {{#each transcript}}
      <p>{{this}}</p>
    {{/each}}
  </div>
</div>
